import React, { useEffect } from "react";
import { createUserAgentApp } from "../helpers/ad";

const AdReply = () => {
  useEffect(() => createUserAgentApp());
  return <div />;
};

export default AdReply;
